"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.netService = exports.UNetService = void 0;
var axios_1 = require("axios");
var ioc_1 = require("@baidu/ioc");
var bce_helper_1 = require("@baidu/bce-helper");
var UNetService = /** @class */ (function () {
    function UNetService() {
    }
    UNetService.setHeader = function (key, value) {
        axios_1.default.defaults.headers.common[key] = value;
    };
    UNetService.setTimeout = function (timeout) {
        axios_1.default.defaults.timeout = timeout;
    };
    UNetService.setUrl = function (url) {
        axios_1.default.defaults.baseURL = url;
    };
    UNetService.setInterceptors = function (interceptors) {
        interceptors.forEach(function (interceptor) {
            axios_1.default.interceptors.request.use(interceptor.request);
            axios_1.default.interceptors.response.use(interceptor.response);
        });
    };
    UNetService.setWithCredentials = function (withCredentials) {
        axios_1.default.defaults.withCredentials = withCredentials;
    };
    UNetService.prototype.get = function (url, params, query, config) {
        if (config === void 0) { config = {}; }
        config.params = params;
        url = this.urlHandler(url, query);
        return this.sendData('get', url, config);
    };
    UNetService.prototype.post = function (url, params, query, config) {
        if (config === void 0) { config = {}; }
        url = this.urlHandler(url, query);
        return this.sendData('post', url, params, config);
    };
    UNetService.prototype.delete = function (url, params, query, config) {
        if (config === void 0) { config = {}; }
        config.params = params;
        url = this.urlHandler(url, query);
        return this.sendData('delete', url, config);
    };
    UNetService.prototype.put = function (url, params, query, config) {
        if (config === void 0) { config = {}; }
        url = this.urlHandler(url, query);
        return this.sendData('put', url, params, config);
    };
    UNetService.prototype.urlHandler = function (url, query) {
        if (query) {
            var assemblyUrlQuery_1 = {};
            Object.keys(query).forEach(function (item) {
                assemblyUrlQuery_1[":".concat(item)] = query[item];
            });
            if (url.includes('http://') || url.includes('https://')) {
                return (0, bce_helper_1.replaceOfString)(url, assemblyUrlQuery_1);
            }
            else {
                return (0, bce_helper_1.replaceOfString)(url, assemblyUrlQuery_1).replace('//', '/');
            }
        }
        else {
            return url;
        }
    };
    UNetService.prototype.sendData = function (methods, url, config1, config2) {
        var _this = this;
        if (config1 === void 0) { config1 = {}; }
        if (config2 === void 0) { config2 = null; }
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        return [4 /*yield*/, axios_1.default[methods](url, config1, config2).then(function (data) {
                                if (!data.data || (0, bce_helper_1.isFalse)(data.data.success)) {
                                    reject(data.data || null);
                                }
                                resolve(data.data);
                            })];
                    case 1:
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        reject(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    UNetService = __decorate([
        (0, ioc_1.Injectable)()
    ], UNetService);
    return UNetService;
}());
exports.UNetService = UNetService;
// 给不想用的依赖注入的人一个便捷方式
exports.netService = (0, ioc_1.Ioc)(UNetService);
